import { SelectableChip } from "@dropbox/dash-component-library";
import { Chip } from "@dropbox/dig-components/chip";
import { UIIcon } from "@dropbox/dig-icons";
import React from "react";

import type { typeahead } from "@mirage/service-typeahead-search/service/types";
import { useIsMobileSize } from "@mirage/shared/responsive/mobile";
import type { SVGProps } from "react";

export type ScopedModeChipProps = {
  src: (props: SVGProps<SVGSVGElement>) => React.ReactElement;
  modeType: typeahead.Mode;
  chipLabel: string;
  onClickHandler: (modeType: typeahead.Mode) => void;
  disabled?: boolean;
  isSelected: boolean;
};

export const ScopedModeChip = ({
  src,
  chipLabel,
  onClickHandler,
  modeType,
  disabled = false,
  isSelected,
}: ScopedModeChipProps) => {
  const isMobile = useIsMobileSize();

  return (
    <SelectableChip
      onClick={() => onClickHandler(modeType)}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.code === "Enter") {
          onClickHandler(modeType);
        }
      }}
      size={isMobile ? "small" : "large"}
      disabled={disabled}
      isSelected={isSelected}
    >
      <SelectableChip.LargeIconAccessory>
        <UIIcon src={src} />
      </SelectableChip.LargeIconAccessory>
      <Chip.Content>{chipLabel}</Chip.Content>
    </SelectableChip>
  );
};
